import { useState } from "react";
import VerticalRegistry from "../../../constants/verticalRegistry";
import { resetSearchFields } from "../utils/searchFields";

const getFirstEnabledSearchField = (searchConfig) => {
  if (!searchConfig) return null;

  const enabledField = Object.keys(searchConfig).find(
    (key) => searchConfig[key] === true,
  );

  if (!enabledField) return null;

  return enabledField;
};

const getSearchConfigByVertical = (vertical) => {
  if (!vertical) return {};

  const verticalConfig = VerticalRegistry.getVerticalByName(vertical);
  if (!verticalConfig.searchConfig) return {};

  return verticalConfig.searchConfig;
};

const useManageStudentForm = (
  { values, handleChange, setFieldValue },
  setSelectedBranch,
) => {
  const searchConfig = getSearchConfigByVertical(values.vertical);

  const [activeCard, setActiveCard] = useState(() =>
    getFirstEnabledSearchField(searchConfig),
  );

  const handleVerticalChange = (e) => {
    const nextVertical = e.target.value;
    const nextSearchConfig = getSearchConfigByVertical(nextVertical);

    handleChange(e);
    setActiveCard(getFirstEnabledSearchField(nextSearchConfig));
    setSelectedBranch(null);
    resetSearchFields(setFieldValue);
    setFieldValue("branch_name", "");
    setFieldValue("branch_id", "");
  };

  const handleTabChange = (nextActiveCard) => {
    if (!searchConfig[nextActiveCard]) return;

    setActiveCard(nextActiveCard);
    resetSearchFields(setFieldValue);
  };

  return { searchConfig, activeCard, handleVerticalChange, handleTabChange };
};

export default useManageStudentForm;
